import { combineEpics } from "redux-observable";
import leaveTypeListEffect from "./leave-type-list-effect";
import leaveTypeAddEffect from "./leave-type-add-effect";
import leaveTypeSaveEffect from "./leave-type-save-effect";
import leaveTypeRemoveEffect from "./leave-type-remove-effect";

export default combineEpics(
	leaveTypeListEffect,
	leaveTypeAddEffect,
	leaveTypeSaveEffect,
	leaveTypeRemoveEffect
);
